<template>
	<section class="page">
		<div class="content">
			<span class="logo_placeholder" ref="placeholder">
				<IconLogoBig ref="logo" />
			</span>
		</div>
		<span class="title" v-if="currentPage.post_title">{{
			currentPage.post_title
		}}</span>

		<div class="content modules_list">
			<template v-for="(module, n) in currentPage.modules">
				<component
					:is="module.type"
					v-bind="module"
					:key="`module_${module.type}_${n}`"
				></component>
			</template>
		</div>
	</section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
// import { PageService } from "@/api";
import IconLogoBig from "@/components/icons/IconLogoBig";
import EventBus from "@/helpers/event-bus";

export default {
	name: "PageView",
	props: {
		slug: String,
	},
	components: {
		IconLogoBig,
	},
	computed: {
		...mapState({
			currentLanguage: (state) => state.site.currentLanguage,
		}),
		...mapGetters("page", ["currentPage"]),
		title() {
			return this.currentPage.seotitle;
		},
	},
	data() {
		return {
			post: false,
		};
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	watch: {
		currentPage() {
			EventBus.$emit(EventBus.page.loaded);
		},
	},
};
</script>

<style lang="scss" scoped>
.page {
	span.title {
		@include gridColumn(s, 12, 0, false, true);
		@include fontH0;
		display: block;

		@include mq($from: xl) {
			@include gridColumn(xl, 14, 1, false, true);
		}
	}

	.logo_placeholder {
		width: 100%;
		opacity: 1;
		display: none;

		@include mq($from: m) {
			@include gridColumn(m, 14, 1, false, true);
			display: block;
			margin-bottom: 75px;
			margin-top: -2vw;
		}

		@include mq($from: l) {
			margin-top: -2.5vw;
		}

		@include mq($from: xl) {
			margin-bottom: 120px;
			@include gridColumn(xl, 10, 2, false, true);
		}

		@include mq($from: 2500px) {
			margin-top: -62px;
		}

		svg {
			width: 100%;
			height: auto;
		}
	}
}
</style>
